import Box from '@mui/system/Box';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { useEffect, useRef, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import MenuItem from '@mui/material/MenuItem';
import {
  usePopupState,
  bindHover,
  bindPopover
} from 'material-ui-popup-state/hooks';
import HoverPopover from 'material-ui-popup-state/HoverPopover';
import { userProfileOptions } from './authUserMenuData';

function ProfileMenu({ userType }: { userType: number }) {
  const [menuBottom, setMenuBottom] = useState<number>(-1);
  const containerRef = useRef<HTMLInputElement>(null);
  const notificationMenuRef = useRef<HTMLInputElement>(null);

  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'notification'
  });

  const calcAndSetMenuBottom = (isForceCalc?: boolean) => {
    if (!notificationMenuRef.current && !isForceCalc) return;
    const { bottom } = containerRef.current.getBoundingClientRect();
    if (bottom !== menuBottom) setMenuBottom(bottom);
  };

  useEffect(() => {
    if (!containerRef.current) return;
    setMenuBottom(containerRef.current.getBoundingClientRect().bottom);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', () => calcAndSetMenuBottom());
    return () => {
      document.removeEventListener('scroll', () => calcAndSetMenuBottom());
    };
  }, []);

  const renderMenuItems = () => {
    const items = [];
    userProfileOptions
      .filter((x) => x.userTypes.includes(userType))
      .forEach((link: UserMenuOptions) => {
        if (link.dividerAbove)
          items.push(<Divider key={`${link.name}divider`} />);
        items.push(
          <MenuItem key={link.name} sx={{ padding: 0 }}>
            <Link
              key={link.name}
              href={link.href}
              underline="none"
              sx={{
                display: 'inline-block',
                width: '100%',
                color: 'black',
                padding: '12px 20px',
                lineHeight: '18px'
              }}>
              {link.name}
            </Link>
          </MenuItem>
        );
        if (link.dividerBelow)
          items.push(<Divider key={`${link.name}divider`} />);
      });
    return items;
  };

  return (
    <>
      <Box
        ref={containerRef}
        sx={{ alignItems: 'center', textAlign: 'center' }}>
        <IconButton
          onPointerEnter={() => calcAndSetMenuBottom(true)}
          {...bindHover(popupState)}
          sx={{
            border: '1px solid white',
            height: '24px',
            width: '24px',
            backgroundColor: 'white',
            marginLeft: '20px',
            '&:hover': {
              backgroundColor: 'white'
            }
          }}>
          <PersonOutlineIcon
            sx={{
              fill: '#299694',
              height: '17px',
              width: '17px'
            }}
          />
        </IconButton>
      </Box>

      <HoverPopover
        ref={notificationMenuRef}
        disableScrollLock
        PaperProps={{
          sx: {
            background: 'transparent',
            border: 'none',
            boxShadow: 'none',
            marginTop: `${menuBottom - 5}px !important`,
            marginLeft: '9px',
            overflow: 'visible',
            top: '0 !important'
          }
        }}
        {...bindPopover(popupState)}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        <Box
          sx={{
            opacity: '0',
            height: '25px'
          }}
        />
        <Box
          sx={{
            backgroundColor: 'white',
            elevation: 0,
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            padding: '10px 0',
            width: '245px',
            '& .MuiMenuItem-root': {
              borderLeft: '7px solid white'
            },
            '& .MuiMenuItem-root:hover': {
              borderLeft: '7px solid #09b3b0',
              backgroundColor: 'rgba(186,232,231,.3)'
            },
            '& .MuiMenuItem-root:focus': {
              borderLeft: '7px solid #09b3b0',
              backgroundColor: 'rgba(186,232,231,.3)'
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'relative',
              marginLeft: 'auto',
              marginRight: '3px',
              marginTop: '-6px',
              width: 28,
              height: 16,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0
            }
          }}>
          {renderMenuItems()}
        </Box>
      </HoverPopover>
    </>
  );
}

export default ProfileMenu;
